export var ProjectConfigurationKeyEnum;
(function (ProjectConfigurationKeyEnum) {
    ProjectConfigurationKeyEnum["ENVIRONMENT_CLASSIFICATION_PATTERNS"] = "ENVIRONMENT_CLASSIFICATION_PATTERNS";
    ProjectConfigurationKeyEnum["DYNAMODB_PROJECT_FULL_SCAN_THRESHOLD_DURATION"] = "DYNAMODB_PROJECT_FULL_SCAN_THRESHOLD_DURATION";
})(ProjectConfigurationKeyEnum || (ProjectConfigurationKeyEnum = {}));
